export default "__VITE_ASSET__D0_Yex3l__"